import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByKey',
})
export class FilterByKeyPipe implements PipeTransform {
  transform<T>(values: T[] | null | undefined, keyName: string, keyVal: unknown): T[] {
    if (!values || values.length === 0) return [];
    return values.filter((val) => (val as Record<string, unknown>)[keyName] === keyVal);
  }
}
